import React from 'react';
import { PeekBox, PeekStack, PeekButton } from '@piiqtechnologies/ui-components';
import { Edit2 } from '@piiqtechnologies/svg-icons';
import { usePannellumViewer } from '../../../components/pannellum-viewer/PannellumProvider.js';
import BackButton from '../../../components/viewer-back-button/index.js';
import { ExtractPhoto } from './extract-photo/ExtractPhoto.js';
import { ExtractPhotoTools } from './extract-photo/ExtractPhotoTools.js';

const EditorButtonMenu = ({ onEditTour, extractPhotoTool, toggleExtractPhotoTool, }) => {
    const { details: contextDetails, spaceId } = usePannellumViewer();
    const editTour = contextDetails._id === spaceId;
    if (extractPhotoTool) {
        return React.createElement(ExtractPhotoTools, { closeExtractPhotoTool: toggleExtractPhotoTool });
    }
    return (React.createElement(PeekBox, { sx: { position: "absolute", top: "0", left: "0", zIndex: 1 }, width: "100%" },
        React.createElement(PeekStack, { sx: { p: 1.5 }, direction: "row", justifyContent: "flex-end", spacing: 1 },
            React.createElement(PeekBox, null,
                React.createElement(BackButton, null)),
            editTour && (React.createElement(React.Fragment, null,
                React.createElement(PeekBox, null,
                    React.createElement(PeekButton, { onClick: onEditTour, variant: "contained", "area-label": "Edit Tour", startIcon: React.createElement(Edit2, null) }, "Edit Tour")),
                React.createElement(ExtractPhoto, { openExtractPhotoTool: toggleExtractPhotoTool }))))));
};

export { EditorButtonMenu, EditorButtonMenu as default };
